import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// layouts
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// no layouts views
import { AuthGuard } from "./guards/auth-guard.guard";
import { DefaultComponent } from "./layouts/default/default.component";
import { InventarioLayout } from "./layouts/inventario/inventario.component";
import { ForbiddenComponent } from "./pages/forbidden/forbidden.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { AlertasComponent } from "./views/admin/alertas/alertas.component";
import { ReportsComponent } from "./views/admin/reportes/reportes.component";
import { UsersComponent } from "./views/admin/users/users.component";
import { EmpresasComponent } from "./views/catalogs/empresas/empresas.component";
import { FuncionamientoComponent } from "./views/catalogs/funcionamiento/funcionamiento.component";
import { PlantasComponent } from "./views/catalogs/plantas/plantas.component";
import { ProveedoresComponent } from "./views/catalogs/proveedores/proveedores.component";
import { TiposMaterialesComponent } from "./views/catalogs/tipos-materiales/tipos-materiales.component";
import { TiposServiciosComponent } from "./views/catalogs/tipos-servicios/tipos-servicios.component";
import { TiposUnidadesComponent } from "./views/catalogs/tipos-unidades/tipos-unidades.component";
import { InventarioComponent } from "./views/materials/inventario/inventario.component";
import { MaterialsComponent } from "./views/materials/materials/materials.component";
import { MovementsComponent } from "./views/materials/movements/movements.component";
import { ActasAdminComponent } from "./views/otros/actas/actas.component";
import { CajaComponent } from "./views/otros/caja/caja.component";
import { CartasComponent } from "./views/otros/cartas/cartas.component";
import { AsignacionComponent } from "./views/recepcion/asignacion/asignacion.component";
import { EntregaComponent } from "./views/recepcion/entrega/entrega.component";
import { HistorialUnidadComponent } from "./views/recepcion/historial/historial.component";
import { RecepcionComponent } from "./views/recepcion/recepcion/recepcion.component";
import { RevisionPercancesComponent } from "./views/recepcion/revision/revision.component";
import { UnidadesComponent } from "./views/recepcion/unidades/unidades.component";
import { CampanaComponent } from "./views/taller/campana/campana.component";
import { HistorialMantenimientoComponent } from "./views/taller/historial/historial.component";
import { MantenimientoComponent } from "./views/taller/mantenimiento/mantenimiento.component";
import { ProgramarComponent } from "./views/taller/programar/programar.component";
import { BlackListComponent } from "./views/workers/blacklist/blacklist.component";
import { IdCardsComponent } from "./views/workers/idcards/idcards.component";
import { OperadoresComponent } from "./views/workers/operadores/operadores.component";

const routes: Routes = [
  // dash views
  {
    path: "admin",
    component: DefaultComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        data: { permiso: ["admin_dash"] },
        canActivate: [AuthGuard],
      },
      {
        path: "alertas",
        component: AlertasComponent,
        data: { permiso: ["admin_alerts"] },
        canActivate: [AuthGuard],
      },
      {
        path: "reportes",
        component: ReportsComponent,
        data: { permiso: ["admin_reportes"] },
        canActivate: [AuthGuard],
      },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
    ],
    data: { urlToPass: "auth/login" },
  },
  // office views
  {
    path: "office",
    component: DefaultComponent,
    children: [
      {
        path: "caja",
        component: CajaComponent,
        data: { permiso: ["office_caja"] },
        canActivate: [AuthGuard],
      },
      {
        path: "cartas",
        component: CartasComponent,
        data: { permiso: ["office_cartas"] },
        canActivate: [AuthGuard],
      },
      {
        path: "actas",
        component: ActasAdminComponent,
        data: { permiso: ["office_actas"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "admin/dashboard", need: "recibir" },
  },
  // unit views
  {
    path: "unit",
    component: DefaultComponent,
    children: [
      {
        path: "listado",
        component: UnidadesComponent,
        data: { permiso: ["unit_lista"] },
        canActivate: [AuthGuard],
      },
      {
        path: "asignacion",
        component: AsignacionComponent,
        data: { permiso: ["unit_asignacion"] },
        canActivate: [AuthGuard],
      },
      {
        path: "revision",
        component: RevisionPercancesComponent,
        data: { permiso: ["unit_percances"] },
        canActivate: [AuthGuard],
      },
      {
        path: "historial",
        component: HistorialUnidadComponent,
        data: { permiso: ["unit_historial"] },
        canActivate: [AuthGuard],
      },
      // { path: "polizas", component: PolizasComponent },
      {
        path: "entrega/:id",
        component: EntregaComponent,
        data: { permiso: ["unit_entrega"] },
        canActivate: [AuthGuard],
      },
      {
        path: "entrega",
        component: EntregaComponent,
        data: { permiso: ["unit_entrega"] },
        canActivate: [AuthGuard],
      },
      {
        path: "recepcion/:id",
        component: RecepcionComponent,
        data: { permiso: ["unit_recibir"] },
        canActivate: [AuthGuard],
      },
      {
        path: "recepcion",
        component: RecepcionComponent,
        data: { permiso: ["unit_recibir"] },
        canActivate: [AuthGuard],
      },
      {
        path: "",
        component: UnidadesComponent,
        data: { permiso: ["unit_lista"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "admin/dashboard", need: "recibir" },
  },
  // warehouse views
  {
    path: "warehouse",
    component: InventarioLayout,
    children: [
      {
        path: "movimientos",
        component: MovementsComponent,
        data: { permiso: ["warehouse_moves"] },
        canActivate: [AuthGuard],
      },
      {
        path: "inventario",
        component: InventarioComponent,
        data: { permiso: ["warehouse_inventario"] },
        canActivate: [AuthGuard],
      },
      {
        path: "materiales",
        component: MaterialsComponent,
        data: { permiso: ["warehouse_materials"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "auth/login" },
  },
  // taller views
  {
    path: "taller",
    component: DefaultComponent,
    children: [
      {
        path: "mantenimientos",
        component: MantenimientoComponent,
        data: { permiso: ["taller_mant"] },
        canActivate: [AuthGuard],
      },
      {
        path: "programar",
        component: ProgramarComponent,
        data: { permiso: ["taller_programar"] },
        canActivate: [AuthGuard],
      },
      {
        path: "campana",
        component: CampanaComponent,
        data: { permiso: ["taller_campana"] },
        canActivate: [AuthGuard],
      },
      {
        path: "historial",
        component: HistorialMantenimientoComponent,
        data: { permiso: ["taller_historial"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "auth/login" },
  },
  // workers views
  {
    path: "workers",
    component: DefaultComponent,
    children: [
      {
        path: "index",
        component: OperadoresComponent,
        data: { permiso: ["worker_index"] },
        canActivate: [AuthGuard],
      },
      {
        path: "blacklist",
        component: BlackListComponent,
        data: { permiso: ["worker_banned"] },
        canActivate: [AuthGuard],
      },
      {
        path: "idcards",
        component: IdCardsComponent,
        data: { permiso: ["worker_credenciales"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "auth/login" },
  },
  // catalogs views
  {
    path: "catalogs",
    component: DefaultComponent,
    children: [
      {
        path: "tpmat",
        component: TiposMaterialesComponent,
        data: { permiso: ["cats_tpmat"] },
        canActivate: [AuthGuard],
      },
      {
        path: "tpserv",
        component: TiposServiciosComponent,
        data: { permiso: ["cats_tpserv"] },
        canActivate: [AuthGuard],
      },
      {
        path: "tpunidad",
        component: TiposUnidadesComponent,
        data: { permiso: ["cats_tpunidad"] },
        canActivate: [AuthGuard],
      },
      {
        path: "proveedores",
        component: ProveedoresComponent,
        data: { permiso: ["cats_proveedores"] },
        canActivate: [AuthGuard],
      },
      {
        path: "empresas",
        component: EmpresasComponent,
        data: { permiso: ["cats_empresas"] },
        canActivate: [AuthGuard],
      },
      {
        path: "plantas",
        component: PlantasComponent,
        data: { permiso: ["cats_plantas"] },
        canActivate: [AuthGuard],
      },
      {
        path: "funcionamiento",
        component: FuncionamientoComponent,
        data: { permiso: ["cats_funcion"] },
        canActivate: [AuthGuard],
      },
      {
        path: "users",
        component: UsersComponent,
        data: { permiso: ["cats_usuarios"] },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
    data: { urlToPass: "auth/login" },
  },
  // auth views
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "login", component: LoginComponent },
      { path: "register", component: RegisterComponent },
      { path: "", redirectTo: "login", pathMatch: "full" },
    ],
  },
  // no layout views
  { path: "403", component: ForbiddenComponent , canActivate: [AuthGuard]},
  { path: "404", component: NotFoundComponent , canActivate: [AuthGuard]},
  { path: "**", redirectTo: "/404" }, // Catch-all for 404
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
